import React, { useEffect, useState } from 'react';
import {DataGrid} from '@material-ui/data-grid';
import _ from 'lodash';
import {Box} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import { RenderCellExpand } from "./RenderCellExpand";
import { handleEditOrderModal } from '../../reducers/uiSlice';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import EditOrderModal from '../EditOrderModal';
import { useDispatch } from 'react-redux';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%', 
        width: '100%', 
        "& .MuiDataGrid-columnsContainer": {
            backgroundColor: '#212121'
        },
        "& .MuiDataGrid-iconSeparator": {
            display: "none"
        },
        "& .MuiDataGrid-root .MuiDataGrid-cell--textLeft": {
            textAlign: 'center'
        },
        "& .MuiDataGrid-colCellTitle": {
            marginLeft: '20px'
        },
        "& .MuiDataGrid-row.Mui-odd": {
            backgroundColor: "#303030"
        },
        "& .MuiDataGrid-row.Mui-even": {
            backgroundColor: "#424242"
        }
    },
    countOrder: {
        marginRight: theme.spacing(1),
    },
    countStyle: {
        display: "inline-block !important", 
        marginRight: '5px' 
    }
}));

export default function SecondDeliveryOrderTable(props) {
    const classes = useStyles();
    const {t} = useTranslation('secondDelivery');
    const dispatch = useDispatch();

    const {isLoading, orderListCurr, onOrderSelected} = props

    const columns = [
        {
            field: 'storage_info', 
            headerName: t('storage_info'), 
            width: 130, 
            headerAlign: 'center'
        },
        {
            field: 'order_time', 
            headerName: t('order_time'), 
            width: 170, 
            headerAlign: 'center'
        },
        {
            field: 'parcel_id', 
            headerName: t('parcel_id'), 
            width: 200, 
            headerAlign: 'center'
        },
        {
            field: 'path_info',
            headerName: t('path_info'), 
            width: 200,
            headerAlign: 'center'
        },
        {
            field: 'original_tno', 
            headerName: t('original_tno'), 
            width: 200, 
            headerAlign: 'center'
        },
        {
            field: 'original_path_info',
            headerName: t('original_path_info'),
            width: 200,
            headerAlign: 'center'
        },
        {
            field: 'driver_id',
            headerName: t('driver_id'),
            width: 160,
            headerAlign: 'center'
        },
        {
            field: 'driver_name',
            headerName: t('driver'),
            description: 'This column has a value getter and is not sortable.',
            width: 200,
            headerAlign: 'center',
            renderCell: RenderCellExpand
        },
        {
            field: 'driver_notes',
            headerName: t('driver_notes'),
            width: 260,
            headerAlign: 'center',
            renderCell: RenderCellExpand
        }     
    ];

    const [orderList, setOrderList] = useState([]);
    const [tno, setTno] = useState('');
    const [tnoType, setTnoType] = useState('');
    const [editOrderModalOpen, setEditOrderModalOpen] = useState(false);

    function handleEditModalClose() {
        setEditOrderModalOpen(false);
    }
    function handleEditOrderModalOpen(tno, searchType) {
        setTno(tno);
        setTnoType(searchType);
        setEditOrderModalOpen(true);
    }
    function currentlySelected(params) {
        const value = params.colDef.field;
        if(value === 'parcel_id') {
            handleEditOrderModalOpen(params.formattedValue, 'tno')
            dispatch(handleEditOrderModal({open: true}));
        } else if(value === 'original_tno') {
            handleEditOrderModalOpen(params.formattedValue, 'tno')
            dispatch(handleEditOrderModal({open: true}));
        }
    }

    useEffect(() => {
        if(orderListCurr) {
            orderListCurr.map((order) => {
                if(order.path_info === 0) {
                    order.path_info = t('not_delivered');
                } else if(order.path_info === 1) {
                    order.path_info = t('out_for_delivery');
                } else if(order.path_info === 2) {
                    order.path_info = t('delivered');
                }
            })
            setOrderList(orderListCurr)
        }
    }, [orderListCurr])

    return (
        <Box className={classes.root}>
            <EditOrderModal
                 open={editOrderModalOpen} 
                 tno={tno} 
                 tnoType={tnoType}
                 onClose={handleEditModalClose} 
                 handleClose={handleEditModalClose} 
                 byResendOrder={true} 
            />
            <div style={{flex: 1}}>
                <DataGrid
                    loading={isLoading}
                    alignItems="center"
                    rows={orderList.map((row) => createRow(row))}
                    columns={columns}
                    pageSize={20}
                    onSelectionModelChange={(newSelection) => {
                        onOrderSelected(newSelection)
                    }}
                    checkboxSelection
                    onCellClick={currentlySelected}
                />
            </div>
        </Box>
    );

    function createRow({
        order_id,
        storage_info,
        add_time,
        parcel_id,
        path_info,
        original_tno,
        original_path_info,
        driver_id,
        driver_name,
        driver_notes
    }) {
        let id = order_id;
        let order_time = moment(add_time * 1000).format('YYYY-MM-DD HH:mm:ss');

        return {
            id,
            storage_info,
            order_time,
            parcel_id,
            path_info,
            original_tno,
            original_path_info,
            driver_id,
            driver_name,
            driver_notes
        };
    }

    // function createRow({
    //     order_id,
    //     storage_info,
    //     add_time,
    //     order_sn,
    //     second_pathInfo,
    //     orginal_tno,
    //     pathInfo,
    //     driver_id,
    //     driver_name,        
    //     driver_notes
    // }) {
    //     let id = order_id;
    //     let order_time = moment(add_time * 1000).format('YYYY-MM-DD HH:mm:ss');
    //     return {
    //         id,
    //         storage_info,
    //         order_time,
    //         order_sn,
    //         second_pathInfo,
    //         orginal_tno,
    //         pathInfo,
    //         driver_id,
    //         driver_name,
    //         driver_notes
    //     };
    // }
}

SecondDeliveryOrderTable.defaultProps = {
    orderList: [],
    isLoading: false
}
